import store from "../store"
import { TAX_ACCOUNTANT_USEFUL_SITE } from "../store/data/actionTypes"

export const taxAccountantUsefulSiteToggle = () => {

  store.dispatch({
    type: TAX_ACCOUNTANT_USEFUL_SITE,
    payload: 'toggle'
  })
}

export default taxAccountantUsefulSiteToggle